import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface SettingsSectionProps {
  title?: string;
  description?: string;
  icon?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
  contentClassName?: string;
}

export default function SettingsSection({
  title,
  description,
  icon,
  actions,
  children,
  className,
  contentClassName,
}: SettingsSectionProps) {
  return (
    <section
      className={cn(
        'w-full min-w-0 max-w-full mx-auto',
        className,
      )}
    >
      {(title || description || actions) && (
        <header className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2 mb-4 min-w-0">
          <div className="min-w-0 flex-1">
            {title && (
              <h2 className="text-lg sm:text-xl font-semibold text-gray-900 dark:text-white flex items-center gap-2 min-w-0">
                {icon}
                <span className="truncate">{title}</span>
              </h2>
            )}
            {description && (
              <p className="text-sm text-gray-500 dark:text-gray-400 mt-1 break-words">
                {description}
              </p>
            )}
          </div>
          {actions && (
            <div className="flex items-center gap-2 flex-shrink-0">{actions}</div>
          )}
        </header>
      )}
      <div
        className={cn(
          'w-full min-w-0 max-w-full overflow-hidden rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 p-3 sm:p-4 lg:p-6',
          '[&>*]:min-w-0 [&>*]:w-full [&>*]:max-w-full [&>*]:overflow-hidden',
          contentClassName,
        )}
      >
        {children}
      </div>
    </section>
  );
}
